module.exports = __webpack_public_path__ + "img/c2.d55bf5c5.png";